const NAMESPACE = "addContentItemDialog";

const KEYS = {
    goBackButton: "goBackButton",
    selectItemLabel: "selectItemLabel",
    contentLibraryLabel: "contentLibraryLabel",
    publicLibraryLabel: "publicLibraryLabel",
    programLibraryLabel: "programLibraryLabel",
    selectedItemNoneText: "selectedItemNoneText",
    invalidProgramIdMessage: "invalidProgramIdMessage"
};

const MESSAGES = {
    [KEYS.goBackButton]: {
        value: "Go Back",
        comment: "Text for go back button"
    },
    [KEYS.selectItemLabel]: {
        value: "Select Item:",
        comment: "Label prompting use to select item from content library"
    },
    [KEYS.contentLibraryLabel]: {
        value: "Content Library",
        comment: "Label for content libray"
    },
    [KEYS.publicLibraryLabel]: {
        value: "Public Library",
        comment: "Label for public library"
    },
    [KEYS.programLibraryLabel]: {
        value: "Program Library",
        comment: "Label for program library"
    },
    [KEYS.selectedItemNoneText]: {
        value: "None",
        comment: "Text to show user if no item selected."
    },
    [KEYS.invalidProgramIdMessage]: {
        value: "Invalid parent ID",
        comment: "Message to show user if invalid parend id used"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
